import { Outlet, createRootRoute, useLocation } from '@tanstack/react-router'
import { AdminGate } from '@/features/shared/pages/admin-gate'

function RootComponent() {
  const location = useLocation()
  if (location.pathname === '/login') return <Outlet />
  return (
    <AdminGate>
      <Outlet />
    </AdminGate>
  )
}

export const Route = createRootRoute({
  component: RootComponent,
})
